import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EyeIcon } from '@/components/icons/EyeIcon';
import { EyeSlashIcon } from '@/components/icons/EyeSlashIcon';
import { IconTooltipButton } from '@/components/iconTooltipButton/IconTooltipButton';

import { FormikText, TFormikTextProps } from './FormikText';

type TFormikPasswordProps<T> = TFormikTextProps<T> & {
  toggleButtonTestId?: string;
};

export const FormikPassword = <PError extends unknown>({
  toggleButtonTestId,
  ...props
}: TFormikPasswordProps<PError>) => {
  const { t } = useTranslation();
  // true = the password is shown as plain text. The toggle label names the action a click performs.
  const [explicit, setExplicit] = useState(false);

  const Icon = explicit ? EyeSlashIcon : EyeIcon;
  return (
    <FormikText
      type={explicit ? 'text' : 'password'}
      endAdornment={
        <IconTooltipButton
          size="small"
          label={explicit ? t('common.hidePassword') : t('common.showPassword')}
          onClick={() => setExplicit(!explicit)}
          sx={({ palette }) => ({
            color: palette.text.primary,
            marginRight: '-5px',
          })}
          data-testid={toggleButtonTestId}
        >
          <Icon fontSize="small" />
        </IconTooltipButton>
      }
      {...props}
    />
  );
};
